import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import CustomRichTextEditor from './customRichTextEditor';

const ControlledRichTextEditor = ({ name, control, defaultValue = '', disabled = false }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <>
          <div style={{border: `${error ? '1' : '0'}px solid #D32F2F`, borderRadius: 4, overflow: 'hidden',}}>
            <CustomRichTextEditor
              ref={ref}
              value={value}
              disabled={disabled}
              onChange={onChange}
            />
          </div>
          {error && <Typography fontSize={'12px'} color='error' margin={"4px 14px 0px"}>{error.message}</Typography>}
        </>
      )}
    />
  );
};

ControlledRichTextEditor.propTypes = {
  name: PropTypes.string.isRequired, // Field name for react-hook-form
  control: PropTypes.object.isRequired, // react-hook-form's control object
  defaultValue: PropTypes.string, // Initial content for the editor
  disabled: PropTypes.bool, // Whether the editor is editable
};

export default ControlledRichTextEditor;
